// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__23NLe","productName":"Table_productName__Bujfv"};